<router-outlet />
<app-alert-bar></app-alert-bar>
<app-message-modal />

<div [ngClass]="{'style-ngx-spinner': showRefreshButton }">
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#118cfc" type="ball-scale-pulse" [fullScreen]="true">
    <div class="text-center flex flex-col items-center justify-center">
      <p style="color: white">Breathe in, Breathe out 😌 </p>
      @if (showRefreshButton) {
      <p style="color: white">Please Refresh</p>
      <app-button [label]="'Refresh'" (clickEvent)="onRefreshClick()"></app-button>
      }
    </div>
  </ngx-spinner>
</div>
<div style="height:100%">
  <app-loader></app-loader>
</div>
